import { ComponentPropsWithoutRef, FC } from "react";
import Button from "./Button";
import Typography from "./Typography";

type InfoProps = {
  title?: string;
  description: string;
  ctaLabel?: string;
  onClickCta: () => void;
} & ComponentPropsWithoutRef<"div">;

const Info: FC<InfoProps> = ({
  title,
  description,
  ctaLabel,
  onClickCta,
  ...rest
}) => {
  return (
    <div
      // One message, one CTA, and that CTA is the way out — so the enclosing
      // Dialog's own close X stands down rather than doubling it (see
      // `CONTENT_OWNS_CLOSE` in components/Dialog.tsx).
      data-owns-dialog-close=""
      {...rest}
      className={`${rest.className} text-center text-slate-950 dark:text-foreground`}
    >
      {title && (
        <Typography variant="h4" className="mb-4">
          {title}
        </Typography>
      )}
      <Typography variant="body1" className="text-gray-600">
        {description}
      </Typography>
      <Button className="mt-8 mx-auto w-full" onClick={onClickCta} size="l">
        {ctaLabel}
      </Button>
    </div>
  );
};

export default Info;
